<template>
<div>
  <div class="tabs">
    <ul>
      <router-link exact tag="li" :to="{ name: 'standard-manager', params: { standard: $route.params.standard }}">
        <a>Overview</a>
      </router-link>
      <router-link tag="li" :to="{ name: 'standard-sections', params: { standard: $route.params.standard }}">
        <a>Sections</a>
      </router-link>
      <router-link tag="li" :to="{ name: 'edit-standard', params: { standard: $route.params.standard }}">
        <a>Edit</a>
      </router-link>
    </ul>
  </div>
  <router-view />
</div>
</template>

<script>
export default {
  created() {
    this.$store.dispatch('standard/loadStandard', this.$route.params.standard)
  }
}
</script>